// A deliberately-imperfect sample register: three clean rows and one (ARR-003) with a missing
// provider and reversed dates - so the readiness view has real blocking issues (F1 + F10) to show.
// Arrangement references are unique so the sample promotes cleanly to the live register; the
// register-uniqueness invariant that rejects duplicates on promotion is exercised by the tests.
export const SAMPLE_CSV = [
  "Contract Ref,Vendor Code,Vendor Name,Country,Function Code,Function,Start,End,Annual Spend,Criticality",
  "ARR-001,AWS-EU,Amazon Web Services EMEA,LU,FN-CORE,Core banking platform,2022-04-01,2027-03-31,480000,critical",
  "ARR-002,STRIPE,Stripe Payments Europe,IE,FN-PAY,Card acquiring,2023-01-15,2026-01-14,150000,critical",
  "ARR-003,,Unknown SaaS,NL,FN-HR,HR system,2025-06-01,2024-06-01,22000,important",
  "ARR-004,DATADOG,Datadog EU,FR,FN-OBS,Observability,2024-02-01,2027-02-01,60000,not critical",
].join("\n");

// A verified-flow sample: template B_01.02 with datapoint-code headers. Row 2 has a bad LEI and
// negative total assets, so the verified EBA v4.0 rules produce real (warning) findings.
export const SAMPLE_B0102 = [
  "B_01.02",
  "0010,0020,0030,0040,0050,0070,0080,0100,0110",
  "5493001KJTIIGC8Y1R12,Acme Payments NV,NL,eba_CT:x12,eba_RP:x53,2025-12-31,2025-01-01,EUR,1000000",
  "NOTALEI,Beta Data BV,DE,eba_CT:x12,eba_RP:x56,2025-12-31,2025-01-01,EUR,-5",
].join("\n");
